<script>
    export default {
        props: {
          endpoint: {
              type: String,
              required: true,
          },
          rate: {
              type: Number,
              default: 60000
          }
        },
        mounted() {
            setTimeout(this.keepAlive(), this.rate);
        },
        methods: {
            keepAlive() {
                let timestamp = Math.round(new Date().getTime() / 1000);
                window.App.Axios.get(this.endpoint + '?t=' + timestamp).then(() => {
                    setTimeout(this.keepAlive, this.rate);
                }).catch(() => {
                    if (console && console.warn) {
                        console.warn('Keep alive failed, stop requesting.');
                    }
                });
            }
        },
        render() {
            return '';
        }
    }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/platform/access/assets/js/components/KeepAlive.vue